var host = document.location.hostname;
if (host == "localhost") {
    var BackendUrl = 'https://sastanablockchainbackend.osiztech.com/';
    var BackendUrl1 = 'http://172.16.16.123:4581/';

} else {
    var BackendUrl = 'https://sastanablockchainbackend.osiztech.com/';
    var BackendUrl1 = 'http://172.16.16.123:4581/';

}
export var BackendUrl;